// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\JobOrder\ApiJobOrder.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { ApprovalOfCharges, ApprovalOfChargesData, ApprovalOfChargesOptions } from 'data/models/ApprovalOfCharges';
import { BillCoverage, BillCoverageData, BillCoverageOptions } from 'data/models/BillCoverage';
import { Change, ChangeData, ChangeOptions } from 'data/models/Change';
import { JobOrderSelf, JobOrderSelfData, JobOrderSelfOptions } from 'data/models/JobOrderSelf';
import { JobOrderVersion, JobOrderVersionData, JobOrderVersionOptions } from 'data/models/JobOrderVersion';
import { PilotJobOrder, PilotJobOrderData, PilotJobOrderOptions } from 'data/models/PilotJobOrder';
import { PortCall, PortCallData, PortCallOptions } from 'data/models/PortCall';
import { QuickBooksJobTracking, QuickBooksJobTrackingData, QuickBooksJobTrackingOptions } from 'data/models/QuickBooksJobTracking';
import { ScheduleDateEntity, ScheduleDateEntityData, ScheduleDateEntityOptions } from 'data/models/ScheduleDateEntity';

// JobOrderData is the class that JobOrder serializes to/from
export interface JobOrderData {
    Id : number;
	
    _approvalsOfCharges : ApprovalOfChargesData[] | null;
    Bills : BillCoverageData[] | null;
    Change : ChangeData | null;
    ChangeId : number;
    PilotJobOrder : PilotJobOrderData | null;
    PortCall : PortCallData | null;
    PortCallId : number;
    Schedule : ScheduleDateEntityData[] | null;
    Self : JobOrderSelfData | null;
    Version : JobOrderVersionData | null;
	
    Billable : boolean;
    Guid : /* GUID */ string;
    QBTracking : QuickBooksJobTrackingData;
}

// JobOrderOptions is the class which may be passed to the JobOrder constructor to define optional initial data values
export interface JobOrderOptions {
    Id : number;
	
    _approvalsOfCharges? : ApprovalOfChargesOptions[] | null;
    Bills? : BillCoverageOptions[] | null;
    Change? : ChangeOptions | null;
    ChangeId? : number;
    PilotJobOrder? : PilotJobOrderOptions | null;
    PortCall? : PortCallOptions | null;
    PortCallId? : number;
    Schedule? : ScheduleDateEntityOptions[] | null;
    Self? : JobOrderSelfOptions | null;
    Version? : JobOrderVersionOptions | null;
	
    Billable? : boolean;
    Guid? : /* GUID */ string;
    QBTracking? : QuickBooksJobTrackingOptions;
}

export class JobOrder {
    public Id : DataSignal<number>;
	
    public _approvalsOfCharges : SDataArray<ApprovalOfCharges>;
    public Bills : SDataArray<BillCoverage>;
    public Change : DataSignal<Change | null>;
    public ChangeId : DataSignal<number>;
    public PilotJobOrder : DataSignal<PilotJobOrder | null>;
    public PortCall : DataSignal<PortCall | null>;
    public PortCallId : DataSignal<number>;
    public Schedule : SDataArray<ScheduleDateEntity>;
    public Self : DataSignal<JobOrderSelf | null>;
    public Version : DataSignal<JobOrderVersion | null>;
	
    public Billable : DataSignal<boolean>;
    public Guid : DataSignal<string>;
    public QBTracking : QuickBooksJobTracking;

    constructor();
    constructor(data : JobOrderOptions);
    constructor(data: JobOrderOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this._approvalsOfCharges = SArray<ApprovalOfCharges>([]);
        this.Bills = SArray<BillCoverage>([]);
        this.Change = S.value<Change | null>(null);
        this.ChangeId = jsonableObservable(S.value<number>(data && data.ChangeId !== undefined ? data.ChangeId : 0));
        this.PilotJobOrder = S.value<PilotJobOrder | null>(null);
        this.PortCall = S.value<PortCall | null>(null);
        this.PortCallId = jsonableObservable(S.value<number>(data && data.PortCallId !== undefined ? data.PortCallId : 0));
        this.Schedule = SArray<ScheduleDateEntity>([]);
        this.Self = S.value<JobOrderSelf | null>(null);
        this.Version = S.value<JobOrderVersion | null>(null);
	    
        this.Billable = jsonableObservable(S.value<boolean>(data && data.Billable !== undefined ? data.Billable : false));
        this.Guid = jsonableObservable(S.value<string>(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.QBTracking = data && data.QBTracking !== undefined ? new QuickBooksJobTracking(data.QBTracking) : new QuickBooksJobTracking();
    }

    static key(obj : JobOrder) {
        return obj.Id();
    }
    
    static dataKey(obj : JobOrderOptions) {
        return obj.Id;
    }

    static update(obj : JobOrder, data : JobOrderOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
            if (data.ChangeId !== undefined) obj.ChangeId(data.ChangeId);
            if (data.PortCallId !== undefined) obj.PortCallId(data.PortCallId);
	        
            if (data.Billable !== undefined) obj.Billable(data.Billable);
            if (data.Guid !== undefined) obj.Guid(data.Guid);
            if (data.QBTracking !== undefined) QuickBooksJobTracking.update(obj.QBTracking, data.QBTracking);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/JobOrder.ts